module.exports = __webpack_public_path__ + "img/badge-list-thumb-093.f5e8c95a.png";